<div class="with-floating-button">
    <div class="content">
        <page-header [title]="'admin.parametres.formulaire.title' | translate" [listeItems]="listeTabItems" [selectedIndex]="selectedIndex" (onSelectedItemChange)="onSelectedItemChange($event)">
        </page-header>
        <router-outlet></router-outlet>
    </div>
</div>